

































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import { PlanHeader } from "@/entity/Ppe/PlanHeader";
import PlanGeneralInfo from "./modules/PlanGeneralInfo.vue";
import { PlanDetail } from "@/entity/Ppe/PlanDetail";
import { PPE_AUTHORIZATION, PPE_PDF, PPE_STATUS, PPE_UOM } from "@/services/Enums";
import { PlanAuthorization } from "@/entity/Ppe/PlanAuthorization";
import { i18n } from "@/i18n/i18n-setup";
import { PlanTarget } from "@/entity/Ppe/PlanTarget";
import { IPlanProducts } from "@/interfaces/IPlanProduct";
import { PPE_PRODUCT_TYPE } from "@/services/Enums";
import PlanProductsManage from "./modules/PlanProductsManage.vue";
import { GetDropdownCountriesForUser, GetDropDownListBySource, SyncPpeDropdowns, SOURCE } from "@/services/PpeDropDowns";
import PlanForecastVolumeCosts from "./modules/PlanForecastVolumeCosts.vue";
import PlanAttachmentsDetail from "./modules/PlanAttachmentsDetail.vue";
import { PlanAttachment } from "@/entity/Ppe/PlanAttachment";
import PlanEvaluationForm from "./modules/PlanEvaluationForm.vue";
import { PlanFinal } from "@/entity/Ppe/PlanFinal";
import {IPlanBaseInfo} from "@/interfaces/IPlanBaseInfo";
import { saveAs } from 'file-saver';
import { UnitOfMeasurement } from "@/entity/Ppe/UnitOfMeasurement";

@Component({
  components: {
    PlanGeneralInfo,
    PlanProductsManage,
    PlanForecastVolumeCosts,
    PlanAttachmentsDetail,
    PlanEvaluationForm
  }
})
export default class PlanDetails extends Vue {
  @Prop({ type: String, required: false })
  planHeaderId;
  @Prop({ type: Array, required: false })
  dropDownCountriesProp: Array<any>;

  authorizedUser: boolean = true;
  parentMounted: boolean = false;
  tabActivated: number = 0;
  loading: boolean = false;
  isSaveClicked: boolean = false;
  isSaveDraftClicked: boolean = false;

  plan: PlanHeader = new PlanHeader();
  symbolUnitOfMeasurementPlan : string = "";
  kSymbolUnitOfMeasurementPlan : string = "";
  planProductConfirmation: string = "";
  planCountryManagerEndorsement: string = "";
  planTargetTotalVolumeYearBefore: number = 0;
  
  planHeaderEditable: boolean = false;
  planDetailEditable: boolean = false;
  planTargetEditable: boolean = false;
  planFinalEditable: boolean = false;
  countryManagerEndorsementEditable: boolean = false;
  productConfirmationEditable: boolean = false;
  saveAllowed: boolean = false;
  attachmentUpload: boolean = false;
  nextAllowed: boolean = false;
  refuseAllowed: boolean = false;
  downloadEvaluationReportPdfAllowed: boolean = false;
  downloadPromotionPlanPdfAllowed: boolean = false;

  dropDownCountries: Array<any> = [];
  dropDownProductConfirmation: Array<any> = [];

  PRODUCT_TYPE = PPE_PRODUCT_TYPE;
  ppePdfType: any = PPE_PDF;

  costAllocationSectionVisibility: boolean = false;
  includedProductModuleKey: number = 0;
  costAllocationModuleKey: number = 0;

  setCostAllocationSectionVisibility() {
    this.costAllocationSectionVisibility = !this.plan.detail.costAllocationCheck;
  }

  handleTotalVolumeLastYearChange(event) {
    this.planTargetTotalVolumeYearBefore = Number(event);
  }

  relatedTabVisibility() {
    if(this.plan.status >= PPE_STATUS.TARGET_CHECK)
      return true;
    else
      return false;
  }

  evaluationFormTabVisibility() {
    if(this.plan.status >= PPE_STATUS.IN_PROGRESS)
      return true;
    else
      return false;
  }

  onChangeAllBrand() {
    this.includedProductModuleKey = this.includedProductModuleKey + 1;
  }

  onChangeCostAllocationAllBrand() {
    this.costAllocationModuleKey = this.costAllocationModuleKey + 1;
  }
  
  async mounted() {
    this.loading = true;
    if(this.dropDownCountriesProp == null) {
      this.dropDownCountries = await GetDropdownCountriesForUser(this.planHeaderId == null ? true : false);
    } else {
      this.dropDownCountries = this.dropDownCountriesProp;
    }
    this.dropDownProductConfirmation = await GetDropDownListBySource(SOURCE.PRODUCT_CONFIRMATION);
    await SyncPpeDropdowns();
    
    if(this.planHeaderId != null) {
      await this.getPlanById(this.planHeaderId);
    } else {
      let baseInfo = await this.getBasePlanInfo();

      this.plan.unitOfMeasurement = new UnitOfMeasurement();
      this.symbolUnitOfMeasurementPlan = PPE_UOM.LITERS;
      this.kSymbolUnitOfMeasurementPlan = 'GENERIC.UOM_K_LITERS';
      this.plan.unitOfMeasurement.symbol = this.symbolUnitOfMeasurementPlan;
      this.plan.unitOfMeasurement.kSymbol = this.kSymbolUnitOfMeasurementPlan;

      this.plan.detail = new PlanDetail();
      this.plan.detail.costAllocationCheck = true;
      this.plan.detail.allBrands = true;
      this.plan.status = 0;
      this.plan.target = new PlanTarget();
      this.plan.authorization = new PlanAuthorization();
      this.plan.productsIncluded = new Array<IPlanProducts>();
      this.plan.productsExcluded = new Array<IPlanProducts>();
      this.plan.productsCostAllocation = new Array<IPlanProducts>();
      this.plan.attachments = new Array<PlanAttachment>();
      this.plan.mrkMngSign = baseInfo.marketingManagerName;
      this.plan.mrkHeadSign = baseInfo.headOfMarketingName;
      if (baseInfo.place && baseInfo.date)
        this.plan.placeDate = baseInfo.place + ', ' + General.formatDateIt(baseInfo.date);
      this.setFormAuthorizationNewPlan();
      
      this.loading = false; 
      this.parentMounted = true;
    }
    if(this.authorizedUser) {
      if(this.plan.target.productionConfirmation != null)
        this.planProductConfirmation = this.plan.target.productionConfirmation;
        
      if(this.plan.target.countryManagerEndorsement != null)
        this.planCountryManagerEndorsement = this.plan.target.countryManagerEndorsement;
    }
  }

  initDraftPlan() {
    if(this.plan.detail == null) {
      this.plan.detail = new PlanDetail();
      this.plan.detail.costAllocationCheck = true;
    }

    if(this.plan.target == null) 
      this.plan.target = new PlanTarget();
  }

  async getPlanById(planHeaderId: string) {
    try {
      let response = await axios({
        method: "get",
        url: General.GetApiUrl("/api/ppe/GetPlanById?planHeaderId=" + planHeaderId),
        withCredentials: true,
        responseType: "json",
      });
      this.plan = response.data;
      this.symbolUnitOfMeasurementPlan = this.plan.unitOfMeasurement.symbol;
      this.kSymbolUnitOfMeasurementPlan = this.plan.unitOfMeasurement.kSymbol;
      this.planTargetTotalVolumeYearBefore = this.plan.target != null ? this.plan.target.totalVolumeYearBefore : 0;

      this.initDraftPlan();
      this.setCostAllocationSectionVisibility();
      this.setFormAuthorization();
      this.initPlanFinal();

      this.loading = false;
      this.parentMounted = true;
    } catch (error) {
      if(error.response.status == 403) {
        this.parentMounted = false;
        this.authorizedUser = false;
        this.$emit("unauthorized");
      } else {
        General.HandleError(error, this);
        this.parentMounted = false;
      }
    }
  }

  async getBasePlanInfo():Promise<IPlanBaseInfo>{
    try {
      let response = await axios({
        method: "get",
        url: General.GetApiUrl("/api/ppe/GetPlanBaseInfo"),
        withCredentials: true,
        responseType: "json",
      });
      return response.data;

    } catch (error) {
      General.HandleError(error, this);
      this.parentMounted = false;
    }
  }
  returnCountryManagerAlert(refused: boolean = false) {
    return !this.planCountryManagerEndorsement && this.plan.status == PPE_STATUS.TARGET_CHECK && !refused
  }

  async save(isDraft: boolean = true, refused: boolean = false) { 
    if(!isDraft && !refused) {
      this.isSaveClicked = true;
      if(this.isValidForm()) {
        if(this.returnCountryManagerAlert(refused)) {
          General.confirm(
            i18n.t('PPE.CONFIRM_COUNTRY_MANAGER_ENDORSEMENT_ABSENCE') as string,
            this,
            async () => {
              await this.doSave(isDraft, refused);
            }
          );
        } else {
          await this.doSave(isDraft, refused);
        }
      }
    } else {
      this.isSaveDraftClicked = true;
      if(this.isValidFormNewPlan()) 
        await this.doSave(isDraft, refused);
    }
  }

  async doSave(isDraft: boolean = true, refused: boolean = false) {
    if(!refused) {
      General.confirm(
        i18n.t('GENERIC.CONFIRM_MESSAGE') as string,
        this,
        async () => {
          if(this.planHeaderId != null)
            await this.updatePlan(isDraft);
          else
            await this.createPlan(isDraft);
        }
      );
    } else {
      General.confirm(
        i18n.t('PPE.CONFIRM_PPE_REFUSING') as string,
        this,
        async () => {
            await this.updatePlan(isDraft, refused);
        }
      );
    }
  }

  async createPlan(isDraft: boolean = true) {
    try {
      this.loading = true;
      let response = await axios.post(General.GetApiUrl('/api/ppe/CreatePlan?isDraft=' + isDraft)
                                      ,this.plan
                                      ,{ withCredentials: true });
      if(response.data != null) {
        let numericId: string = response.data;

        General.showAlertSuccess(i18n.t('PPE.PLAN_CREATED') as string, this);
        this.isSaveClicked = false;
        this.isSaveDraftClicked = false;
        this.closeDetailModal();
        this.$emit("plan-created", numericId);
      }
    } catch (error) {
        General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  async updatePlan(isDraft: boolean = true, refused: boolean = false) {
    try {
      this.loading = true;

      if(this.productConfirmationEditable)
        this.plan.target.productionConfirmation = this.planProductConfirmation;
      
      if(this.countryManagerEndorsementEditable)
        this.plan.target.countryManagerEndorsement = this.planCountryManagerEndorsement;

      if(this.planFinalEditable)
        this.plan.target.totalVolumeYearBefore = this.planTargetTotalVolumeYearBefore;

      await axios.post(General.GetApiUrl('/api/ppe/UpdatePlan?isDraft=' + isDraft + '&isRefused=' + refused)
                                    ,this.plan
                                    ,{ withCredentials: true });

      General.showAlertSuccess(i18n.t('PPE.PLAN_UPDATED') as string, this);
      this.isSaveClicked = false;
      this.closeDetailModal();
      this.$emit("plan-updated", this.plan.numericId);
    } catch (error) {
        General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  closeDetailModal() {
    this.$bvModal.hide("plan-details-modal");
  }

  isValidFormNewPlan() {
    let isValid = true;
    if(this.CheckIsNullOrEmpty(this.plan.idCountryFrom)) {
      this.tabActivated = 0;
      isValid = false;
      General.showAlertDanger(i18n.t('GENERIC.CHECK_MANDATORY_FIELDS') as string, this);
    }
    return isValid;
  }

  isValidForm() {
    let validGeneralInfo = this.isValidGeneralInfo();
    let validProductsIncluded = this.isValidProductsIncluded();
    let validProductsCostAllocation = this.isValidProductsCostAllocation();
    let validForecastVolumeAndCost = this.isValidForecastVolumeAndCost();
    let validEvaluationForm = this.isValidEvaluationForm();

    if(!validGeneralInfo){
      this.tabActivated = 0;
      General.showAlertDanger(i18n.t('GENERIC.CHECK_MANDATORY_FIELDS') as string, this);
    } else if(!validProductsIncluded) {
      this.tabActivated = 1;
      General.showAlertDanger(i18n.t('PPE.CHECK_PRODUCTS_INCLUDED') as string, this);
    } else if(!validProductsCostAllocation) {
      this.tabActivated = 1;
      General.showAlertDanger(i18n.t('PPE.CHECK_PRODUCTS_COST_ALLOCATION') as string, this);
    } else if(!validForecastVolumeAndCost) {
      this.tabActivated = 2;
      General.showAlertDanger(i18n.t('PPE.CHECK_FORECAST_VOLUME_COST') as string, this);
    } else if(!validEvaluationForm) {
      this.tabActivated = 6;
      General.showAlertDanger(i18n.t('PPE.CHECK_EVALUATION_FORM') as string, this);
    }
    return validGeneralInfo && validProductsIncluded && validProductsCostAllocation  && validForecastVolumeAndCost && validEvaluationForm;
  }

  isValidGeneralInfo() {
    let isValid: boolean = true;
    if(this.CheckIsNullOrEmpty(this.plan.idCountryFrom)
        || this.CheckIsNullOrEmpty(this.plan.creator)
        || this.CheckIsNullOrEmpty(this.plan.placeDate)
        || this.CheckIsNullOrEmpty(this.plan.mrkMngSign)
        || this.CheckIsNullOrEmpty(this.plan.mrkHeadSign)
        || this.CheckIsNullOrEmpty(this.plan.cnyMngSign)
        //PLAN DETAIL VALIDATION
        || this.CheckIsNullOrEmpty(this.plan.detail.title)
        || this.CheckIsNullOrEmpty(this.plan.detail.targetCustomer1)
        || this.CheckIsNullOrEmpty(this.plan.detail.targetCustomer2)
        || this.CheckIsNullOrEmpty(this.plan.detail.dtStart)
        || this.CheckIsNullOrEmpty(this.plan.detail.dtEnd)
        || this.CheckIsNullOrEmpty(this.plan.detail.benefits)
        || this.CheckIsNullOrEmpty(this.plan.detail.planGoal)
        || this.CheckIsNullOrEmpty(this.plan.detail.mechanics)
        || this.CheckIsNullOrEmpty(this.plan.detail.mechanicsDescription)
        || this.CheckIsNullOrEmpty(this.plan.detail.supportMaterials)
        || (this.CheckIsNullOrEmpty(this.plan.detail.targetVolume) && this.CheckIsNullOrEmpty(this.plan.detail.target)
        )
    ) {
      isValid = false;
    }

    return isValid;
  }

  isValidProductsIncluded() {
    let isValid: boolean = true;
    if(!this.plan.detail.allBrands && (this.plan.productsIncluded == undefined || this.plan.productsIncluded == null || this.plan.productsIncluded.length == 0))
      isValid = false;
    return isValid;
  }

  isValidProductsCostAllocation() {
    let isValid: boolean = true;
    if(!this.plan.detail.costAllocationCheck && (!this.plan.detail.allBrandsCost && (this.plan.productsCostAllocation == undefined || this.plan.productsCostAllocation.length == 0))) 
      isValid = false;
    return isValid;
  }

  isValidForecastVolumeAndCost() {
    let isValidTargetVolume: boolean = true;
    let isValidTarget: boolean = true;
    let isValidOtherField: boolean = true;
    if(!this.CheckIsNullOrEmpty(this.plan.detail.targetVolume)) {
      if(this.CheckIsNullOrEmpty(this.plan.target.totalVolumeTons) || this.CheckIsNullOrEmpty(this.plan.target.incidenceKg) || 
        (!this.plan.isImported && (this.CheckIsNullOrEmpty(this.plan.target.grossProfit) || this.CheckIsNullOrEmpty(this.plan.target.lastYearVolumeBaseLine))))
        isValidTargetVolume = false;
    }

    if(!this.CheckIsNullOrEmpty(this.plan.detail.target)) {
      if(this.CheckIsNullOrEmpty(this.plan.target.totalVolumeEuroDurance) || this.CheckIsNullOrEmpty(this.plan.target.incidenceEuro))
      isValidTarget = false;
    }

    if(this.CheckIsNullOrEmpty(this.plan.target.costPPE) || this.CheckIsNullOrEmpty(this.plan.target.budgetIncidence))
      isValidOtherField = false;

    return isValidTargetVolume && isValidTarget && isValidOtherField;
  }

  isValidEvaluationForm() {

    let isValidTargetVolume: boolean = true;
    let isValidTarget: boolean = true;
    let isValidOtherField: boolean = true;

    if(this.plan.status >= PPE_STATUS.IN_PROGRESS) {
      if(!this.CheckIsNullOrEmpty(this.plan.target.totalVolumeTons)) {
        if(this.CheckIsNullOrEmpty(this.plan.final.totalVolumeTons) || this.CheckIsNullOrEmpty(this.plan.final.incidenceKg))
          isValidTargetVolume = false;
      }

      if(!this.CheckIsNullOrEmpty(this.plan.target.totalVolumeEuroDurance)) {
        if(this.CheckIsNullOrEmpty(this.plan.final.totalVolumeEuroDurance) || this.CheckIsNullOrEmpty(this.plan.final.incidenceEuro))
        isValidTarget = false;
      }

      if(this.CheckIsNullOrEmpty(this.plan.final.costPPE) || this.CheckIsNullOrEmpty(this.plan.final.evaluationMark) || 
        (!this.plan.isImported && (this.CheckIsNullOrEmpty(this.plan.final.grossProfit) || this.CheckIsNullOrEmpty(this.plan.target.lastYearVolumeBaseLine))))
        isValidOtherField = false;

    }

    return isValidTargetVolume && isValidTarget && isValidOtherField;
  }

  setFormAuthorization() {
    this.resetFormAuthorization();
    if(this.plan.authorization.planHeader === PPE_AUTHORIZATION.WRITE) {
      this.planHeaderEditable = true;
    }
    if(this.plan.authorization.planDetail === PPE_AUTHORIZATION.WRITE) {
      this.planDetailEditable = true;
    }
    if(this.plan.authorization.planTarget === PPE_AUTHORIZATION.WRITE) {
      this.planTargetEditable = true;
    }
    if(this.plan.authorization.planFinal === PPE_AUTHORIZATION.WRITE) {
      this.planFinalEditable = true;
    }
    if(this.plan.authorization.countryManagerEndorsement === PPE_AUTHORIZATION.WRITE) {
      this.countryManagerEndorsementEditable = true;
    }
    if(this.plan.authorization.productConfirmation === PPE_AUTHORIZATION.WRITE) {
      this.productConfirmationEditable = true;
    }
    this.saveAllowed = this.plan.authorization.saveAllowed;
    this.attachmentUpload = this.plan.authorization.attachmentUpload;
    this.nextAllowed = this.plan.authorization.nextAllowed;
    this.refuseAllowed = this.plan.authorization.refuseAllowed;

    this.downloadEvaluationReportPdfAllowed = this.plan.status == PPE_STATUS.CLOSED;
    this.downloadPromotionPlanPdfAllowed = this.plan.status >= PPE_STATUS.IN_PROGRESS;
  }

  resetFormAuthorization() {
    this.planHeaderEditable = false;
    this.planDetailEditable = false;
    this.planTargetEditable = false;
    this.planFinalEditable = false;
    this.countryManagerEndorsementEditable = false;
    this.productConfirmationEditable = false;
    this.saveAllowed = false;
    this.attachmentUpload = false;
    this.nextAllowed = false;
    this.refuseAllowed = false;
  }

  setFormAuthorizationNewPlan(){
    this.planHeaderEditable = true;
    this.planDetailEditable = true;
    this.planTargetEditable = true;
    this.saveAllowed = true;
    this.attachmentUpload = true;
    this.nextAllowed = true;
  }

  CheckIsNullOrEmpty(text: any) {
    if (text == null) return true;
    if (text.toString() === '') return true;
    return false;
  }

  getDisabledState(authorization: boolean) {
      if(authorization) {
        return false;
      }
      else {
          return true; 
      }
  }

  onChangeCostAllocationCheck() {
    if(!this.plan.detail.costAllocationCheck) {
        while(this.plan.productsCostAllocation.length) {
            this.plan.productsCostAllocation.pop();
        }
    }
  }

  initPlanFinal() {
    if(this.plan.status >= PPE_STATUS.IN_PROGRESS && this.planFinalEditable) {
      if(this.plan.final == null) {
        this.plan.final = new PlanFinal()
        this.plan.final.idHeader = this.planHeaderId;
      } else {
        this.planTargetTotalVolumeYearBefore = this.plan.target.totalVolumeYearBefore;
      }
    }
  }

  async downloadPpePdf(ppePdfType: PPE_PDF) {
    try {
        let url = "/api/ppe/";
        if(ppePdfType == PPE_PDF.PROMOTION_PLAN)
          url = url + "GetPromotionalPlanPdfById?planId=";
        else
          url = url + "GetFinalReportPlanPdfById?planId=";

        let response = await axios({
            method: 'get',
            url: General.GetApiUrl(url + this.plan.id),
            withCredentials: true,
            responseType: 'blob'
        });
        let filename = response.headers['content-disposition'].split('filename=')[1];
        saveAs(new Blob([response.data]), filename);
    } catch (error) {
        General.showAlertDanger(i18n.t('GENERIC.DOWNLOAD_FILE_ERROR') as string, this);                               
    }
  }

}
